import * as React from 'react';
import { ApplicationMain } from 'src/styles/common';
import LoaderComponent from 'src/components/common/loader.component';
import { DataCollectorDashboardWrapper } from 'src/styles/datacollectordashboard';
import { Grid, IconButton, Typography } from '@material-ui/core';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { getCurrentUrl } from 'src/effects/utils/common';
import pdfLogo from './../assets/images/pdf.png'
import WordLogo from './../assets/images/word.png'
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { getCountriesAssignedToUser } from '../actions/action.module';
import { downloadWebinarDocument, downloadWebinarZipDocument } from 'src/effects/api/api.report';
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo';
import ArchiveOutlinedIcon from '@material-ui/icons/ArchiveOutlined';

class DashboardWebnairContainer extends React.Component<any, any> {
    state = {
        spacing: '16',
        videoIframeSrc: '',
    };
    constructor(props: any) {
        super(props);

        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.getSelectedCountry = this.getSelectedCountry.bind(this);
        this.handleDownloadWebinarDocument = this.handleDownloadWebinarDocument.bind(this);
        this.handleDownloadWebinarZipDocument = this.handleDownloadWebinarZipDocument.bind(this);
        this.redirectToWebinarVideo = this.redirectToWebinarVideo.bind(this);
    }

    componentDidMount() {
        this.props.getCountriesAssignedToUser();
        getCurrentUrl().then((currUrl: any) => {
            const splitUrl = currUrl.split("/");
            const reportId = parseInt(splitUrl[splitUrl.length - 1], 10);
            this.setState({
                videoIframeSrc: this.getReportIframeSrc(reportId)
            });
        });
        
    }
    handleCountryChange = (event: any) => {
        this.setState({ countryId: event.target.value });
        // updateCurrentActiveCountryCall(event.target.value);
        // this.props.dashboard(event.target.value);
    }

    getSelectedCountry() {
        let selectedCountry: any;
        const state: any = this.state;
        const countryId: any = parseInt(state.countryId, 10);
        if (this.props.countryData.countries.length > 0) {
            selectedCountry = this.props.countryData.countries.find((val: any) => val.id === countryId);
        }

        return selectedCountry ? selectedCountry.name : '';
    }

    redirectToWebinarVideo(reportId: any) {
        this.setState({
            videoIframeSrc: this.getReportIframeSrc(reportId)
        });
    }

    getReportIframeSrc(reportId: any) {
        let videoIframeSrc = "";

        switch (reportId) {
            case 1:
                {

                    videoIframeSrc ="https://player.vimeo.com/video/425490934";
                }
                break;
            case 2:
                {
                    videoIframeSrc = "https://player.vimeo.com/video/425500260";
                }
                break;
            case 3:
                {
                    videoIframeSrc = "https://player.vimeo.com/video/425500713";
                }
                break;
            default:
                {
                    videoIframeSrc ="https://player.vimeo.com/video/425490934";
                }
                break;
        }
        return videoIframeSrc;
    }
    handleDownloadWebinarDocument(webinarId: any) {
        downloadWebinarDocument(webinarId);
    }

    handleDownloadWebinarZipDocument(webinarId: any, fileName: string) {
        downloadWebinarZipDocument(webinarId, fileName);
    }
    

    render() {
        // const data = this.props.data && this.props.data.payload;
        // const user = getLocalStorageValue('user');
        return (
            <ApplicationMain>
                <LoaderComponent sending={this.props.show} />

                <DataCollectorDashboardWrapper>
                    <div className="pageContainer dashboardWebinarScreen">
                        <div className="pageHeading">
                            {/* <Grid container={true} spacing={8}>
                                <Grid item={true} xs={6}>
                                    <div className="pageTitleSection">
                                        <Typography component="h2" variant="title" align="left" gutterBottom={true} className="pageTitle">
                                            Welcome, {user ? user.firstName + ' ' + user.lastName : ''}
                                        </Typography>
                                    </div>
                                </Grid>
                                <Grid item={true} xs={6}>
                                    <div className="pagesLinks text-right">
                                        <ul>
                                            <li className="listItem">
                                                <span className="changeCountry">Change Country</span>
                                            </li>
                                            <li className="listItem">
                                                <FormControl fullWidth={false}>
                                                    <Select
                                                        // value={this.state.countryId}
                                                        onChange={this.handleCountryChange}
                                                        // input={<Input name="country" id="age-auto-width" />}
                                                        autoWidth={false}
                                                        id="countryList"
                                                    >
                                                        <MenuItem key={0} value={0}>Select</MenuItem>
                                                        {
                                                            this.props.countryData && this.props.countryData.countries ?
                                                                this.props.countryData.countries.map((mt: any) => {
                                                                    return (
                                                                        <MenuItem key={mt.id} value={mt.id}>{mt.name}</MenuItem>
                                                                    )
                                                                })
                                                                :
                                                                ''
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </li>
                                        </ul>
                                    </div>
                                </Grid>
                            </Grid> */}

                            <Grid container={true} spacing={8}>
                                <Grid item={true} xs={6}>
                                    <div className="pageTitleSection">
                                        <Link to={{ pathname: `/data-collector-dashboard` }}>
                                            <IconButton className="backButton" color="inherit" aria-label="Open drawer">
                                                <KeyboardBackspaceIcon />
                                            </IconButton>
                                        </Link>

                                        <Typography component="h2" variant="title" align="left" gutterBottom={true} className="pageTitle strongText">
                                            NutriDash Webinar Materials
                                        </Typography>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>

                        <div className="pageContent">

                            <div className="contentSection">
                                <Grid container={true} spacing={24}>
                                    <Grid item={true} xs={6}>

                                        <div className="media-list-wrapper">

                                            <div className="media-webinar-heading">
                                                <p>The following files are accompaniments to the Nutridash Webinars</p>
                                            </div>

                                            <div className="media-list" onClick={this.handleDownloadWebinarDocument.bind(this, 1)} >

                                                <div className="media-content">
                                                    <div className="media-left media-box media-box-primary media-box-large">
                                                        <img src={WordLogo} alt="Success Email Logo" />
                                                    </div>

                                                    <div className="media-body">
                                                        <Typography variant="caption" className="captionText">
                                                            Word File
                                                        </Typography>
                                                        <h5 className="mt-0">Nutridash FAQ</h5>
                                                    </div>

                                                </div>

                                            </div>

                                            <div className="media-list" onClick={this.redirectToWebinarVideo.bind(this, 1)} >

                                                <div className="media-content">
                                                    <div className="media-left media-box media-box-primary media-box-large media-video">
                                                        {/* <img src={PowerpointLogo} alt="Success Email Logo" /> */}
                                                        <OndemandVideoIcon className="OndemandVideoIcon" />
                                                    </div>

                                                    <div className="media-body">
                                                        <Typography variant="caption" className="captionText">
                                                            MP4 File
        </Typography>
                                                        <h5 className="mt-0">NutriDash Webinar 2020 in ENGLISH.mp4</h5>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="media-list" onClick={this.redirectToWebinarVideo.bind(this, 2)} >

                                                <div className="media-content">
                                                    <div className="media-left media-box media-box-primary media-box-large media-video">
                                                        {/* <img src={PowerpointLogo} alt="Success Email Logo" /> */}
                                                        <OndemandVideoIcon className="OndemandVideoIcon" />
                                                    </div>

                                                    <div className="media-body">
                                                        <Typography variant="caption" className="captionText">
                                                            MP4 File
        </Typography>
                                                        <h5 className="mt-0">NutriDash Webinar 2020 in FRENCH.mp4</h5>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="media-list" onClick={this.redirectToWebinarVideo.bind(this, 3)} >

                                                <div className="media-content">
                                                    <div className="media-left media-box media-box-primary media-box-large media-video">
                                                        {/* <img src={PowerpointLogo} alt="Success Email Logo" /> */}
                                                        <OndemandVideoIcon className="OndemandVideoIcon" />
                                                    </div>

                                                    <div className="media-body">
                                                        <Typography variant="caption" className="captionText">
                                                            MP4 File
        </Typography>
                                                        <h5 className="mt-0">NutriDash Webinar 2020 in SPANISH.mp4</h5>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="media-list" onClick={this.handleDownloadWebinarDocument.bind(this, 2)}>

                                                <div className="media-content">
                                                    <div className="media-left media-box media-box-primary media-box-large">
                                                        <img src={pdfLogo} alt="Success Email Logo" />
                                                    </div>

                                                    <div className="media-body">
                                                        <Typography variant="caption" className="captionText">
                                                            PDF File
                                                        </Typography>
                                                        <h5 className="mt-0">NutriDash Webinar 2020 ENGLISH</h5>
                                                    </div>

                                                </div>

                                            </div>
{
                                            /* <div className="media-list" onClick={this.handleDownloadWebinarDocument.bind(this, 3)}>

                                                <div className="media-content">
                                                    <div className="media-left media-box media-box-primary media-box-large">
                                                        <img src={pdfLogo} alt="Success Email Logo" />
                                                    </div>

                                                    <div className="media-body">
                                                        <Typography variant="caption" className="captionText">
                                                            PDF File
                                                        </Typography>
                                                        <h5 className="mt-0">NutriDash Webinar 2020 FRENCH</h5>
                                                    </div>
                                                </div>
                                            </div> */
    }
                                            <div className="media-list" onClick={this.handleDownloadWebinarDocument.bind(this, 4)}>

                                                <div className="media-content">
                                                    <div className="media-left media-box media-box-primary media-box-large">
                                                        <img src={pdfLogo} alt="Success Email Logo" />
                                                    </div>

                                                    <div className="media-body">
                                                        <Typography variant="caption" className="captionText">
                                                            PDF File
                                                        </Typography>
                                                        <h5 className="mt-0">NutriDash Webinar 2020 SPANISH</h5>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="media-list" onClick={this.handleDownloadWebinarZipDocument.bind(this, 10, 'NutriDash Programme Coverage 2018 and Forecast 2020 - Questionnaires in English.zip')} >
                                                <div className="media-content">
                                                    <div className="media-left media-box media-box-primary media-box-large">
                                                        <ArchiveOutlinedIcon className="ArchiveOutlinedIcon" />
                                                    </div>

                                                    <div className="media-body">
                                                        <Typography variant="caption" className="captionText">
                                                            ZIP File
                                                        </Typography>
                                                        <h5 className="mt-0">NutriDash Programme Coverage 2019 and Forecast 2021 - Questionnaires in English.zip</h5>
                                                    </div>
                                                </div>
                                            </div>    
                                                                                    
                                          {


                                            <div className="media-list" onClick={this.handleDownloadWebinarZipDocument.bind(this, 8, 'NutriDash Couverture 2018 et previsions 2020 - Questionnaires en français.zip')} >
                                                <div className="media-content">
                                                    <div className="media-left media-box media-box-primary media-box-large">
                                                        <ArchiveOutlinedIcon className="ArchiveOutlinedIcon" />
                                                    </div>

                                                    <div className="media-body">
                                                        <Typography variant="caption" className="captionText">
                                                            ZIP File
                                                        </Typography>
                                                        <h5 className="mt-0">NutriDash Couverture 2019 et previsions 2021 - Questionnaires en français.zip</h5>
                                                    </div>
                                                </div>
                                            </div>
                                            }

                                            <div className="media-list" onClick={this.handleDownloadWebinarZipDocument.bind(this, 9, 'NitriDash Cobertura 2018 y Prevision 2020 - Cuestionarios en espanol.zip')} >
                                                <div className="media-content">
                                                    <div className="media-left media-box media-box-primary media-box-large">
                                                        <ArchiveOutlinedIcon className="ArchiveOutlinedIcon" />
                                                    </div>

                                                    <div className="media-body">
                                                        <Typography variant="caption" className="captionText">
                                                            ZIP File
                                                        </Typography>
                                                        <h5 className="mt-0">NitriDash Cobertura 2019 y Prevision 2021 - Cuestionarios en espanol.zip</h5>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="media-list" onClick={this.handleDownloadWebinarZipDocument.bind(this, 11, 'NutriDash English Questionnaires 2022.zip')} >
                                                <div className="media-content">
                                                    <div className="media-left media-box media-box-primary media-box-large">
                                                        <ArchiveOutlinedIcon className="ArchiveOutlinedIcon" />
                                                    </div>

                                                    <div className="media-body">
                                                        <Typography variant="caption" className="captionText">
                                                            ZIP File
                                                        </Typography>
                                                        <h5 className="mt-0">NutriDash English Questionnaires 2022.zip</h5>
                                                    </div>
                                                </div>
                                            </div>    

                                            <div className="media-list" onClick={this.handleDownloadWebinarZipDocument.bind(this, 12, 'NutriDash 2022 French Questionnaires.zip')} >
                                                <div className="media-content">
                                                    <div className="media-left media-box media-box-primary media-box-large">
                                                        <ArchiveOutlinedIcon className="ArchiveOutlinedIcon" />
                                                    </div>

                                                    <div className="media-body">
                                                        <Typography variant="caption" className="captionText">
                                                            ZIP File
                                                        </Typography>
                                                        <h5 className="mt-0">NutriDash 2022 French Questionnaires.zip</h5>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="media-list" onClick={this.handleDownloadWebinarZipDocument.bind(this, 13, 'NutriDash - 2021 Cobertura Cuestionarios Español.zip')} >
                                                <div className="media-content">
                                                    <div className="media-left media-box media-box-primary media-box-large">
                                                        <ArchiveOutlinedIcon className="ArchiveOutlinedIcon" />
                                                    </div>

                                                    <div className="media-body">
                                                        <Typography variant="caption" className="captionText">
                                                            ZIP File
                                                        </Typography>
                                                        <h5 className="mt-0">NutriDash - 2021 Cobertura Cuestionarios Español.zip</h5>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            </div>
                                    </Grid>
                                    <Grid item={true} xs={6}>
                                        <div className="iframe-wrapper">
                                            <iframe src={this.state.videoIframeSrc} className="iframe-webinar-video" allow={"autoplay; fullscreen"} />
                                            <p><a href="https://vimeo.com/425490934">NutriDash 3.0 Webinars - June 2020</a> from <a href="https://vimeo.com/user100875542">NutriDash 3.0</a> on <a href="https://vimeo.com">Vimeo</a>.</p>
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                    </div>
                </DataCollectorDashboardWrapper>

            </ApplicationMain>
        )
    }

}

const mapStateToProps = (state: any) => {
    return {
        show: state.common.show,
        countryData: state.model.countryData
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        getCountriesAssignedToUser: () => dispatch(getCountriesAssignedToUser())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardWebnairContainer);



// WEBPACK FOOTER //
// ./src/containers/DashboardWebinarContainer.tsx